"use strict";

require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  eero: true
};
exports.eero = void 0;
var _helpers = require("../helpers");
var _components = require("./components");
var _foundations = require("./foundations");
Object.keys(_foundations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _foundations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _foundations[key];
    }
  });
});
function cov_2pxkz9a1h6() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/index.ts";
  var hash = "415704dd7395fc83a558408875ca06458b05fa7b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 34
        },
        end: {
          line: 32,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "415704dd7395fc83a558408875ca06458b05fa7b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pxkz9a1h6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pxkz9a1h6();
var eero = exports.eero = (cov_2pxkz9a1h6().s[0]++, {
  name: 'eero',
  breakpoints: (0, _helpers.numbersArrWithUnits)(_foundations.breakpoints),
  colors: _foundations.colors,
  fonts: _foundations.fonts,
  fontSizes: _foundations.fontSizesNamedWithUnits,
  fontWeights: _foundations.fontWeights,
  lineHeights: _foundations.lineHeightsWithUnits,
  letterSpacings: _foundations.letterSpacings,
  radii: _foundations.radii,
  shadows: _foundations.shadows,
  space: (0, _helpers.numbersArrWithUnits)(_foundations.space),
  components: _components.components
});